import React from "react";
import {
  SlSocialFacebook,
  SlSocialInstagram,
  SlSocialYoutube,
} from "react-icons/sl";
import { BsTwitterX } from "react-icons/bs";

const Followme = () => {
  return (
    <section>
      <div className="flex gap-1">
        <span className="buttonEffect">
          <a
            href="https://www.facebook.com/phillip.page.963"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialFacebook />
          </a>
        </span>
        <span className="buttonEffect">
          <a
            href="https://www.instagram.com/lgrt_funny/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialInstagram />
          </a>
        </span>
        <span className="buttonEffect">
          <a
            href="https://www.youtube.com/@phillippage6003"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialYoutube />
          </a>
        </span>
        <span className="buttonEffect">
          <BsTwitterX />
        </span>
      </div>
    </section>
  );
};

export default Followme;
